import { render, staticRenderFns } from "./q-table.vue?vue&type=template&id=650c08e7&scoped=true&"
import script from "./q-table.vue?vue&type=script&lang=js&"
export * from "./q-table.vue?vue&type=script&lang=js&"
import style0 from "./q-table.vue?vue&type=style&index=0&id=650c08e7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c08e7",
  null
  
)

export default component.exports